var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "width": "32",
      "height": "32",
      "viewBox": "0 0 32 32",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "d": "M15.855 15.209a4.52 4.52 0 100-9.042 4.52 4.52 0 000 9.042zM8.75 13.917a2.583 2.583 0 010-5.167M22.959 13.917a2.583 2.583 0 000-5.167M26.526 18.567a1.29 1.29 0 00-1.183-.775H6.366a1.291 1.291 0 00-1.184.775L1 28.125h29.708l-4.182-9.558z",
      "stroke": "#F1D5AA",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M9.396 25.542c1.784 0 3.23-1.157 3.23-2.584 0-1.426-1.446-2.583-3.23-2.583-1.783 0-3.229 1.157-3.229 2.583 0 1.427 1.446 2.584 3.23 2.584zM22.313 25.542c1.784 0 3.23-1.157 3.23-2.584 0-1.426-1.446-2.583-3.23-2.583-1.783 0-3.229 1.157-3.229 2.583 0 1.427 1.446 2.584 3.23 2.584zM15.209 22.959h1.292M13.917 25.542h3.875M1 28.125h29.708v1.292a1.292 1.292 0 01-1.291 1.291H2.292A1.292 1.292 0 011 29.417v-1.292zM22.958 13.917V8.104a7.105 7.105 0 00-14.208 0v5.813",
      "stroke": "#F1D5AA",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M9.396 23.282a.323.323 0 010-.646M9.396 23.282a.323.323 0 000-.646M22.313 23.282a.323.323 0 110-.646M22.314 23.282a.323.323 0 100-.646",
      "stroke": "#F1D5AA"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }